import { colors, font } from '@chegg-ui/theme'
import styled from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'
import { Heading2, Body } from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Resources',
})`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
`

export const Wrapper = styled.div`
  max-width: 880px;
  margin: auto;
`

export const Header = styled.h2`
  ${Heading2};
  text-align: center;
  margin: 40px 0 30px 0;
`

export const Card = styled.div`
  margin: 40px 36px;
`

export const CartTitleLinkHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
`

export const CardTitleLink = styled.a`
  &,
  &:link,
  &:visited {
    ${AspiraStack};
    font-size: ${font.size.px16};
    font-weight: ${font.weight.heavy};
    line-height: ${font.lineHeight.md};
    color: ${colors.dark};
    text-decoration: none;
  }
  &:hover,
  &:active {
    text-decoration: underline;
  }
`
export const CardTitleHeader = styled.h3`
  color: ${({ theme }) => theme.Colors.forFonts.fColor08};
  font-weight: 600;
  margin-top: 0px;
`

export const CardText = styled.p`
  ${Body};
`
